export class ProductCombo {
  public id: number;
  public Sku: string;
  public Quantity: number;
  public WidthStacked: number;
  public HeightStacked: number;
  public LengthStacked: number;
}
